export default __webpack_public_path__ + "static/event-4-c2d309ffa53dce1782399e0cdbabfe27.jpg";